module.exports = __webpack_public_path__ + "img/second-page-icon-3.b3d1c239.svg";